import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isMobileOnly } from "react-device-detect";

import { History as history, Routes as routes } from '../navigation';
import { UserActions, NavigationActions, ContextActions, ToastActions, PracticeActions, ConsultationsActions, NotificationsActions } from '../actions';
import { TitleBar, DownloadApp, PracticeEnterpriseMessage, PracticeCodeInfo, CreatePractice, NavBar, LinkedPractices, PracticeProfile, ConsultationsProcessing, ConsultationsResolved, ConsultationsActive, StartConsultation, PracticeUnassignedClients, ProviderWelcomeMessage, PracticePaymentInfo, AppointmentsList, ConsultationsList, UserPhoneEdit, ProviderInvitesSection } from  '../components'

class HomeScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
    const currentRole = this.props.context.selectedRole || '';
    if (currentRole && currentRole === 'front_desk') {
      history.push(routes.FRONT_DESK_HOME);
    } else {
      this.props.contextActions.fetchDataForScreenAndRole('home');
    }
  }

  renderHomeContent = () => {
    const currentRole = this.props.context && this.props.context.selectedRole ? this.props.context.selectedRole : '';
    const isAdminPmPo = currentRole === 'admin' || currentRole === 'practice_owner' || currentRole === 'practice_manager';
    const isProvider  = currentRole === 'vet' || currentRole === 'behaviorist';
    let appointments  = isAdminPmPo ? this.props.schedule.practiceAppointmentIds : this.props.schedule.userAppointmentIds;
    let display_unassigned = !isProvider && this.props.consultations && this.props.consultations.unassignedConsultations &&  this.props.consultations.unassignedConsultations.length > 0 ? true : false;
    let consult_notifications_dict = this.props.notifications.notificationsConsultationsDict ? this.props.notifications.notificationsConsultationsDict : {};
    let preview_consulations = this.props.consultations && this.props.consultations.previewConsultations ? this.props.consultations.previewConsultations : {};
    let user_roles    = this.props.user && this.props.user.roles ? this.props.user.roles : {};
    let role_ids      = Object.keys(user_roles);
    let no_roles      = role_ids.length === 0;
    let practice      = this.props.practice && this.props.practice.practice ? this.props.practice.practice : null;

    if (no_roles) {
      return this.renderNewUserCreatePractice();
    } else if (isMobileOnly) {
      return this.renderDownloadAppSection();
    }

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <ProviderInvitesSection
          token={this.props.user.auth.token}
          userActions={this.props.userActions}
        />
        <PracticeEnterpriseMessage practice={practice} practiceActions={this.props.practiceActions} />
        <UserPhoneEdit hide={true} user={this.props.user.user} userActions={this.props.userActions} token={this.props.user.auth.token} />
        <ConsultationsList
          token={this.props.user.auth.token}
          consultations={preview_consulations}
          status='ACTIVE'
          consultationsActions={this.props.consultationsActions}
          notifications={consult_notifications_dict}
        />
        { display_unassigned
          ? <ConsultationsList
              token={this.props.user.auth.token}
              consultations={preview_consulations}
              status='UNASSIGNED'
              consultationsActions={this.props.consultationsActions}
              notifications={consult_notifications_dict}
            />
          : <ConsultationsList
              token={this.props.user.auth.token}
              consultations={preview_consulations}
              status='RESOLVED'
              consultationsActions={this.props.consultationsActions}
              notifications={consult_notifications_dict}
            />
          }
        <PracticePaymentInfo
          token={this.props.user.auth.token}
          bank={this.props.practice.bank}
          stripeAccount={this.props.practice.stripeAccount}
          practiceActions={this.props.practiceActions}
          displayWhenOutstanding={true}
        />
      </div>
      <div className="screen-container-column">
        <AppointmentsList
          title='Upcoming Appointments'
          token={this.props.user.auth.token}
          displayLimit={5}
          displayOnlyUpcoming={true}
          appointments={this.props.schedule.appointmentsDict}
          appointmentsIds={appointments}
          consultations={this.props.consultations.allConsultations}
          users={this.props.user.users}
          consultationsActions={this.props.consultationsActions}
        />
        { isProvider ? <ProviderWelcomeMessage
          token={this.props.user.auth.token}
          alerts={this.props.practice.alerts}
          userId={this.props.user.auth.user_id}
          selectedPractice={this.props.context.selectedPractice}
          practiceActions={this.props.practiceActions}
        /> : null }
        { isProvider  ? null
                      : <ConsultationsList
                          token={this.props.user.auth.token}
                          consultations={preview_consulations}
                          status='PROCESSING'
                          consultationsActions={this.props.consultationsActions}
                          notifications={consult_notifications_dict}
                        /> }
        <PracticeCodeInfo practice={this.props.practice.practice} />
      </div>
    </div>
  }

  renderDownloadAppSection = () => {
    return <DownloadApp />
  }

  renderNewUserCreatePractice = () => {

    return <div className="flex-container screen-main-content" style={{ paddingTop: 30 }}>
      <div className='flex-container-column'>
        <div className='flex-container-row' style={{ width: 300 }}>
          <ProviderInvitesSection
            token={this.props.user.auth.token}
            userActions={this.props.userActions}
            initialFetch={true}
          />
        </div>
        <CreatePractice
            token={this.props.user.auth.token}
            home_screen={true}
            user_id={this.props.user.auth.user_id}
            toastActions={this.props.toastActions}
            practiceActions={this.props.practiceActions}
          />
      </div>
    </div>
  }

  render() {

    return (
      <div className="flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <NavBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          selectedTab={'my_account'}
          currentRoute={routes.HOME}
          practice={this.props.practice.practice}
          notifications={this.props.notifications}
        />

        { this.renderHomeContent() }

      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    consultations: state.consultations,
    context: state.context,
    practice: state.practice,
    notifications: state.notifications,
    schedule: state.schedule,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
   consultationsActions: bindActionCreators(
    { ...ConsultationsActions }, dispatch),
   toastActions: bindActionCreators(
    { ...ToastActions }, dispatch),
   notificationsActions: bindActionCreators(
    { ...NotificationsActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen)
